import { parseToInsightDateString } from '@/utils/date';

export const toRelationshipContactInitialValues = (contact) => ({
	firstName: contact?.firstName ?? '',
	lastName: contact?.lastName ?? '',
	email: contact?.email ?? '',
	relationshipType: contact?.relationshipType ?? 'other',
	relationshipStatus: contact?.relationshipStatus ?? 'active',
	roleTitle: contact?.roleTitle ?? '',
	relationshipCompanyName: contact?.relationshipCompanyName ?? '',
	relationshipCompanyId: contact?.relationshipCompanyId ?? '',
	mobile: contact?.mobile ?? '',
	lastContactedAt: parseToInsightDateString(contact?.lastContactedAt) ?? '',
	nextActionDate: parseToInsightDateString(contact?.nextActionDate) ?? '',
	nextActionDescription: contact?.nextActionDescription ?? '',
	notesSummary: contact?.notesSummary ?? '',
	isPrimary: Boolean(contact?.isPrimary),
});
